import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Building2, Loader2 } from 'lucide-react';
import { useOrganisation } from '@/contexts/OrganisationContext';
import { useAuth } from '@/contexts/AuthContext';

export function OrganisationAccessRoute({ children }: { children: ReactNode }) {
  const { isLoading, canManagePeople } = useOrganisation();
  const { hasRole } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!canManagePeople && !hasRole('admin')) return <Navigate to="/" replace />;

  return (
    <div data-enterprise-access="granted">
      <span className="sr-only"><Building2 />Organisation access granted</span>
      {children}
    </div>
  );
}
